export default "https://cdn-static.gokick.com/assets/d05c895b658955f243e3d6e9c630166e56cf3faa/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";